import { render, staticRenderFns } from "./EditPostMenuListDialog.vue?vue&type=template&id=a6528b68"
import script from "./EditPostMenuListDialog.vue?vue&type=script&lang=js"
export * from "./EditPostMenuListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports